
import {Component} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';
import {CustomerModule, ShopModule, store, TradeInModule} from "@returns-centre/store";
import {mixins} from 'vue-class-component';
import {FormatDateMixin} from '@returns-centre/mixins';
import _ from 'lodash';
import AppAccordion from "@returns-centre/components/AppAccordion2.vue";
import {AppPagination, TradeInItemProductList} from '@returns-centre/components';

@Component({
    components: {
        AppAccordion,
        AppPagination,
        TradeInItemProductList
    },
    filters: {
        startCase(val: string): string {
            return _.startCase(_.toLower(val));
        }
    }
})
export default class TradeIns extends mixins(FormatDateMixin) {
    tradeInModule = getModule(TradeInModule, store);
    customerModule = getModule(CustomerModule, store);
    shopModule = getModule(ShopModule, store);
    perPage: number = 5;

    async created() {
        await this.getTradeIns();
    }

    getTradeInItemsCount(tradeInItems: TradeInItem[]): number {
        let count: number = 0;
        for (const item of tradeInItems) {
            let qtyRange = _.range(item.quantity);
            count = count + qtyRange.length;
        }
        return count;
    }

    openTradeInDetails(tradeIn: TradeIn) {
        const href = this.$router.resolve({
            name: 'TradeInDetails',
            params: {
                id: tradeIn.id.toString(),
            }
        }).href;
        window.open(href, '_blank');
    }

    openReturnTrackingInformation(tradeIn: TradeIn) {
        const href = this.$router.resolve({
            name: 'TradeInReturnTracking',
            params: {
                trade_in_id: tradeIn.id.toString(),
                return_id: tradeIn.retail_order_return_id
            }
        }).href;
        window.open(href, '_blank');
    }

    onPageChanged(page: number) {
        this.getTradeIns(page);
    }

    async getTradeIns(page: number = 1) {
        if (!this.shopModule.shop) {
            return;
        }
        await this.customerModule.fetchTradeIns({
            shop_id: this.shopModule.shop.id,
            page: page,
            display_length: this.perPage,
        });
    }

    downloadShippingLabel(labelUrl: string) {
        window.open(labelUrl);
    }
}
